import PATTERNS from "./patterns";

const FIELD_TYPE = {
  TEXT: "text",
  GENERATOR: "generator",
  TEXTAREA: "textarea",
  NUMBER: "number",
  DATE: "date",
  DATETIME: "datetime",
  SELECT: "select",
  MULTIPLE_SELECT: "multiple_select",
  CONNECTION: "connection",
  MULTIPLE_CONNECTION: "multiple_connection",
  RATIO: "ratio",
  CHECKBOX: "checkbox",
  HTML: "html",
  AVATAR: "avatar",
  FILE_IMAGES: "file_images",
  FILE_VIDEOS: "file_videos",
  FILE_AUDIOS: "file_audios",
  FILE_OTHERS: "file_others",
  LINK_3DS: "link_3ds",
  LINK_YOUTUBE: "link_youtube",
  MODULE: "module"
};

const DATA_TYPE = {
  ANY: null,
  EMAIL: "email",
  PHONE: "phone",
  LINK: "link",
};

const FILE_TYPE = {
  IMAGE: "image",
  VIDEO: "video",
  AUDIO: "audio",
  OTHER: "other",
};

export const ROLE_ACTION_METHODS = {
  READ: "read",
  CREATE: "create",
  UPDATE: "update",
  DELETE: "delete"
}

export const ROLE_ACTIONS = {
  // Common
  APPROVED_ORDER: "approved_order",
  MANAGEMENT_LOG: "management_log",
  ORDER_STATUS: "order_status",
  ARTIFACT: "artifact",
  NOTABLE: "notable",
  DOCUMENT: "document",
  EVENT: "event",
  EXTRA: "extra",
  CATEGORY: "category",
  FILE: "file",
  TAG: "tag",
  // Auth
  ACCOUNT_MANAGEMENT: "account-management",
  // Fixed
  REPORT_HANDLING: "report-handling",
  CREATE_ACCOUNT: "create-account",
  // Setting
  ORGANIZATION_SETTING: "organization_setting",
  MANAGEMENT_ROLE: "management_role",
  MANAGEMENT_ROLE_USER: "management_role_user"
}

export default {
  APP_TITLE: "Tổ chức QLDS",
  HOTLINE: "0123456789",
  EDITOR_API_KEY: "1oo1lu0sbcnrznvh20hr6tatwezj2zflplh17eataa0p4kft",
  FIELD_TYPE,
  FILE_TYPE,
  OBJECT_TYPES: [
    {
      value: "artifacts",
      label: "Hiện vật",
    },
    {
      value: "notables",
      label: "Nhân vật",
    },
    {
      value: "events",
      label: "Sự kiện",
    },
    {
      value: "documents",
      label: "Tài liệu",
    },
    {
      value: "categories",
      label: "Danh mục"
    }
  ],
  HEADER_ACTIONS: [
    {
      label: "Thêm mới",
      key: "add",
      icon: "el-icon-circle-plus-outline",
      type: "primary",
    },
    {
      label: "Làm mới",
      key: "reset",
      icon: "el-icon-refresh-right",
      type: "primary",
    },
    {
      label: "Import",
      key: "import",
      icon: "el-icon-upload2",
      type: "primary",
    },
    {
      label: "Export",
      key: "export",
      icon: "el-icon-download",
      type: "primary",
    },
    {
      label: "Đồng bộ",
      key: "synchronize",
      icon: "el-icon-s-promotion",
      type: "primary",
      disabled: true,
    },
  ],
  ALL_ACTIONS: [
    {
      label: "Chi tiết",
      key: "detail",
      icon: "el-icon-document",
      type: "primary",
    },
    {
      label: "Danh sách liên kết",
      key: "connection",
      icon: "el-icon-connection",
      type: "default",
    },
    {
      label: "Cấu hình",
      key: "config",
      icon: "el-icon-setting",
      type: "primary",
      plain: true,
      hide: true,
    },
    {
      label: "Thẻ tags",
      key: "tag",
      icon: "el-icon-collection-tag",
      type: "primary",
      plain: true,
    },
    {
      label: "Chỉnh sửa",
      key: "edit",
      icon: "el-icon-edit",
      type: "primary",
    },
    {
      label: "Xóa",
      key: "delete",
      icon: "el-icon-delete",
      type: "danger",
    },
  ],
  FIELD_TYPES: [
    {
      key: FIELD_TYPE.GENERATOR,
      label: "Mã tự động",
      description: "Giá trị được sinh tự động theo một công thức nhất định",
      default: "",
      config: ""
    },
    {
      key: FIELD_TYPE.TEXT,
      label: "Input",
      description: "Chuỗi ký tự ngắn",
      default: "",
    },
    {
      key: FIELD_TYPE.TEXTAREA,
      label: "Textarea",
      description: "Chuỗi ký tự dài",
      default: "",
    },
    {
      key: FIELD_TYPE.NUMBER,
      label: "Number",
      description: "Một số",
      default: 0,
    },
    {
      key: FIELD_TYPE.DATE,
      label: "Date",
      description: "Một ngày",
      default: null,
    },
    {
      key: FIELD_TYPE.DATETIME,
      label: "Date Time",
      description: "Một thời gian",
      default: null,
    },
    {
      key: FIELD_TYPE.HTML,
      label: "Html",
      description: "Nội dung html",
      default: "",
    },
    {
      key: FIELD_TYPE.SELECT,
      label: "Select",
      description: "Select một giá trị từ danh mục",
      default: null,
    },
    {
      key: FIELD_TYPE.MULTIPLE_SELECT,
      label: "Multiple Select",
      description: "Select nhiều giá trị từ danh mục",
      default: [],
    },
    {
      key: FIELD_TYPE.CONNECTION,
      label: "Connection",
      description: "Select một giá trị từ dữ liệu",
      default: null,
    },
    {
      key: FIELD_TYPE.MULTIPLE_CONNECTION,
      label: "Multiple Connection",
      description: "Select nhiều giá trị từ dữ liệu",
      default: [],
    },
    {
      key: FIELD_TYPE.RATIO,
      label: "Ratio",
      description: "Click chọn một giá trị từ list",
      default: null,
    },
    {
      key: FIELD_TYPE.CHECKBOX,
      label: "Checkbox",
      description: "Click chọn một hoặc nhiều giá trị từ list",
      default: [],
    },
    {
      key: FIELD_TYPE.TEXT,
      label: "Input",
      description: "Chuỗi ký tự ngắn",
      default: "",
    },
    {
      key: FIELD_TYPE.AVATAR,
      label: "Avatar",
      description: "Ảnh đại diện/Thumbnail",
      default: "",
    },
    {
      key: FIELD_TYPE.FILE_IMAGES,
      label: "File Images",
      description: "Danh sách ảnh",
      default: [],
    },
    {
      key: FIELD_TYPE.FILE_VIDEOS,
      label: "File Videos",
      description: "Danh sách Video",
      default: [],
    },
    {
      key: FIELD_TYPE.FILE_AUDIOS,
      label: "File Audios",
      description: "Danh sách Audio",
      default: [],
    },
    {
      key: FIELD_TYPE.FILE_OTHERS,
      label: "File khác",
      description: "Danh sách file khác",
      default: [],
    },
    {
      key: FIELD_TYPE.LINK_3DS,
      label: "Link 3Ds",
      description: "Danh sách link 3D",
      default: [],
    },
    {
      key: FIELD_TYPE.LINK_YOUTUBE,
      label: "Link Youtube",
      description: "Danh sách link Youtube",
      default: [],
    },
    {
      key: FIELD_TYPE.MODULE,
      label: "Module",
      description: "",
    },
  ],
  DATA_TYPES: [
    {
      key: DATA_TYPE.ANY,
      pattern: null,
      label: "Mặc định",
    },
    {
      key: DATA_TYPE.EMAIL,
      pattern: PATTERNS.EMAIL,
      label: "Địa chỉ Email",
    },
    {
      key: DATA_TYPE.PHONE,
      pattern: PATTERNS.PHONE,
      label: "Số điện thoại",
    },
    {
      key: DATA_TYPE.LINK,
      pattern: PATTERNS.LINK,
      label: "Link",
    },
  ],
  FORM_WIDTHS: [
    {
      label: "Bằng chiều dài Form",
      value: 24,
    },
    {
      label: "3/4 Chiều dài Form",
      value: 18,
    },
    {
      label: "2/3 Chiều dài Form",
      value: 16,
    },
    {
      label: "1/2 Chiều dài Form",
      value: 12,
    },
    {
      label: "1/3 Chiều dài Form",
      value: 8,
    },
    {
      label: "1/4 Chiều dài Form",
      value: 6,
    },
  ],
  DATE_FORMATS: [
    "DD-MM-YYYY",
    "DD/MM/YYYY",
    "HH:mm DD-MM-YYYY",
    "HH:mm DD/MM/YYYY",
  ],
  BLOCK_TYPES: [
    "categories",
    "category",
    "media",
    "object"
  ],
  BLOCK_KEYS: [
    "id",
    "avatar_url",
    "code",
    "created",
    "creator_id",
    "deleted",
    "extra",
    "extra_en",
    "extra_ch",
    "extra_kr",
    "locales",
    "ordered",
    "organization_id",
    "register_at",
    "tag_ids",
    "type",
    "updated",
    "relations",
    "connection",
  ],
  DOCUMENT_TYPE_ACTION_METHODS: [
    {
      key: ROLE_ACTION_METHODS.READ,
      label: "Xem",
    },
    {
      key: ROLE_ACTION_METHODS.CREATE,
      label: "Thêm",
    },
    {
      key: ROLE_ACTION_METHODS.UPDATE,
      label: "Sửa",
    },
    {
      key: ROLE_ACTION_METHODS.DELETE,
      label: "Xóa",
    }
  ],
  DOCUMENT_TYPE_ACTIONS: [
    // Common
    {
      key: ROLE_ACTIONS.APPROVED_ORDER,
      label: "Phê duyệt nội dung",
      group: "common",
      coming_soon: true
    },
    {
      key: ROLE_ACTIONS.MANAGEMENT_LOG,
      label: "Quản lý log",
      group: "common",
      coming_soon: true
    },
    {
      key: ROLE_ACTIONS.ORDER_STATUS,
      label: "Trạng thái nội dung",
      group: "common",
      coming_soon: true
    },
    {
      key: ROLE_ACTIONS.ARTIFACT,
      label: "Quản lý hiện vật",
      group: "common",
    },
    {
      key: ROLE_ACTIONS.NOTABLE,
      label: "Quản lý nhân vật",
      group: "common",
    },
    {
      key: ROLE_ACTIONS.EVENT,
      label: "Quản lý triển lãm, sự kiện",
      group: "common",
    },
    {
      key: ROLE_ACTIONS.DOCUMENT,
      label: "Quản lý tài liệu",
      group: "common",
    },
    {
      key: ROLE_ACTIONS.EXTRA,
      label: "Quản lý lịch sử phê duyệt",
      group: "common",
    },
    {
      key: ROLE_ACTIONS.CATEGORY,
      label: "Quản lý danh mục",
      group: "common",
    },
    {
      key: ROLE_ACTIONS.FILE,
      label: "Quản lý media",
      group: "common",
    },
    {
      key: ROLE_ACTIONS.TAG,
      label: "Quản lý thẻ Tag",
      group: "common",
    },
    // Setting
    {
      key: ROLE_ACTIONS.MANAGEMENT_ROLE_USER,
      label: "Quản lý tài khoản",
      group: "settings",
      methods: [
        ROLE_ACTION_METHODS.READ,
        ROLE_ACTION_METHODS.UPDATE,
        ROLE_ACTION_METHODS.DELETE
      ]
    },
    {
      key: ROLE_ACTIONS.MANAGEMENT_ROLE,
      label: "Quản lý quyền hạn",
      group: "settings"
    },
    // Auth
    {
      key: ROLE_ACTIONS.ACCOUNT_MANAGEMENT,
      label: "Thông tin tài khoản",
      group: "auth",
      methods: [
        ROLE_ACTION_METHODS.READ,
        ROLE_ACTION_METHODS.UPDATE
      ]
    },
    // Fixed
    {
      key: ROLE_ACTIONS.CREATE_ACCOUNT,
      label: "Tạo tài khoản mới",
      group: "fixed",
      methods: [
        ROLE_ACTION_METHODS.CREATE
      ]
    },
    {
      key: ROLE_ACTIONS.REPORT_HANDLING,
      label: "Báo cáo",
      group: "fixed",
      methods: [
        ROLE_ACTION_METHODS.READ,
      ]
    },
  ],
};
